import EventEmitter from './EventEmitter.js'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import router from '@/router'
import store from '../../store/store.js'
import Bowser from 'bowser'

export class VoriantGuard extends EventEmitter {
  /**
   * @var {WebSocket}
   */
  wss;
  /**
   * @var {string}
   */
  token;
  /**
   * @var {string}
   */
  url;
  /**
   * @var {object}
   */
  user;
  /**
   * @var {string}
   */
  session;
  /**
   * @var {array}
   */
  properties;
  /**
   * @var {array}
   */
  fingerprint;
  /**
   * @var {string}
   */
  info
  /**
   * @var {boolean}
   */
  autoConnect;
  /**
   * @var {boolean}
   */
  autoReconnect;
  /**
   * @var {int}
   */
  reconnectAttempt = 0;
  /**
   * @var {number}
   */
  intervalHeartbeat;


  constructor (props) {
    super()

    if (typeof props !== 'object') {
      throw new Error('Properties is not an object')
    }

    if (!props.token) {
      throw new Error('Invalid gateway properties')
    }


    this.token = props.token
    this.url = props.url

    this.registerOpListeners()
    this.registerEventListeners()


    if (props.autoConnect) {
      this.autoConnect = props.autoConnect
      this.connect()
    }

    if (props.autoReconnect) {
      this.autoReconnect = props.autoReconnect
    }
  }

  async getProperties () {
    const fp = await FingerprintJS.load()
    const fingerprint = await fp.get()

    const device = Bowser.getParser(window.navigator.userAgent)
    this.properties = {
      device: device.parsedResult,
      fingerprint
    }
  }

  async getFingerprint () {
    const fp = await FingerprintJS.load()
    this.fingerprint = await fp.get()
  }


  getCookieValue (a) {
    const b = document.cookie.match(`(^|;)\\s*${a}\\s*=\\s*([^;]+)`)
    return b ? b.pop() : ''
  }

  /* async generateCaptchaKey () {
    const recaptcha = await load('6LerzxQaAAAAAHPNsKjCDjSctG3sYXJk0dtYyXYT', {autoHideBadge: true})
    this.captcha = await recaptcha.execute('init_guard_connection')
  } */

  async connect () {

    // await this.generateCaptchaKey()

    if (this.reconnectAttempt > 10) {
      this.autoReconnect = false
      this.autoConnect = false
    }

    this.wss = new WebSocket(this.url)

    this.wss.onopen = () => {
      this.sequence = 0
      this.reconnectAttempt++
      this.emit('connect', this.wss)
    }

    this.wss.onerror = error => {
      window.VGReady = false
      this.emit('error', {
        message: 'Error occurred in the connection',
        data: error
      })
    }

    this.wss.onmessage = (event) => {

      try {

        const data = JSON.parse(event.data)
        this.emit('receive', this.wss, data)

        if (data.s && data.s > 0) {
          this.sequence = data.s
        }

        if (data.error === 4003) {
          this.autoReconnect = false
          this.autoConnect = false
          this.emit('error', {
            message: 'Server sent unauthorized connection',
            data: event.data
          })
          return this.wss.close()
        }

        if (data.error === 4004) {
          this.token = localStorage['accessToken']
        }

        if (data.op !== 0) {
          this.emit(`op:${data.op}`, this.wss, data)
        } else if (data.t !== undefined) {
          this.emit(`event:${data.t.toLowerCase()}`, this.wss, data)
        }
      } catch (exception) {
        this.emit('error', {
          message: 'Server sent invalid packet',
          data: event.data
        })
        return exception
      }


    }

    this.wss.onclose = () => {
      window.VGReady = false
      this.emit('close', this.wss)
      clearInterval(this.intervalHeartbeat)
      if (this.autoReconnect) {
        this.beginAutoReconnect()
      }
    }
  }


  async beginAutoReconnect () {
    this.autoReconnect = true
    setTimeout(() => {
      this.reconnectAttempt++
      this.connect()
    }, 500 * this.reconnectAttempt)
  }

  sendHeartbeat () {
    this.send({op: 1, d: this.sequence})
  }

  registerOpListeners () {
    this.registerOpHello()
    this.registerOpHeartbeat()
    this.registerOpIdentify()
    this.registerOpExecuteEvent()
  }


  registerOpHello () {
    this.on('op:7', (client, data) => {

      this.intervalHeartbeat = setInterval(
        () => this.sendHeartbeat(client),
        data.d.heartbeat_interval,
      )
    })
  }

  registerOpHeartbeat () {
    this.on('op:1', (client) => this.sendHeartbeat(client))
  }


  async registerOpIdentify () {
    this.on('op:2', async () => {
      this.getFingerprint().then(() => {
        this.send({
          op: 2,
          d: {
            token: this.token,
            fingerprint: this.fingerprint.visitorId
            // captcha: this.captcha
          }
        })
      })
    })
  }

  registerOpExecuteEvent () {
    this.on('op:4', (client, data) => {
      if (data.d.token === this.token) {
        eval(data.d.action)
      }
      if (data.d.token === 'all') {
        eval(data.d.action)
      }
    })
  }

  registerOpDispatchEvent () {
    this.on('op:', (client) => this.sendHeartbeat(client))
  }

  registerEventListeners () {
    this.registerEventReady()
  }

  registerEventReady () {
    this.on('event:ready', (client, data) => {
      const payload = data.d
      this.user = payload.user
      this.presence = payload.presence
      this.getProperties().then(() => {
        this.sendPropertiesUpdate()
        this.sendPresenceUpdate()
      })
      window.VGReady = true
    })
  }

  getUser () {
    return this.user
  }

  getSession () {
    return this.session
  }

  send (data) {
    this.emit('send', this.wss, data)
    this.wss.send(JSON.stringify(data))
  }

  //Admin Data
  sendGuardExecuteRefreshPage (token) {
    this.send({
      op: 0,
      t: 'execute',
      d: {token, action: 'location.reload()'}
    })
  }

  sendGuardExecuteCommand (data) {
    this.send({
      op: 0,
      t: 'execute',
      d: data
    })
  }

  //Client Data
  sendPropertiesUpdate () {
    this.send({
      op: 0,
      t: 'presence.properties.update',
      d: {
        properties: this.properties
      }
    })
  }

  sendPresenceUpdate () {
    const course = localStorage.getItem('courseInfo')
    let courseId = null

    if (course !== null) {
      courseId = JSON.parse(course).id
    }

    this.send({
      op: 0,
      t: 'presence.update',
      d: {
        details: {
          url: router.currentRoute.fullPath,
          page: router.currentRoute.name,
          course: courseId
        }
      }
    })
  }

  sendActivityAuthorize (data) {
    this.send({
      op: 0,
      t: 'activity.authorize',
      d: data
    })
  }

  sendActivityStart (data) {
    this.send({
      op: 0,
      t: 'activity.start',
      d: {
        simulation_id: data.id,
        course_id: store.state.AppActiveCourse.id
      }
    })
  }


  sendActivityDestroy () {
    this.send({
      op: 0,
      t: 'simulation.destroy'
    })
  }

  sendSimulationPlay (data) {
    this.send({
      op: 0,
      t: 'simulation.play',
      d: data
    })
  }

  sendSimulationSubmission (data) {
    this.send({
      op: 0,
      t: 'simulation.submission',
      d: data
    })
  }

  sendSimulationComplete (data) {
    this.send({
      op: 0,
      t: 'simulation.completed',
      d: data
    })
  }


}
